import { verifyRecaptchaTokenAPI } from '../../../adapters/index';
export const initializeRecaptcha = () => {
    if (window.grecaptcha && window.grecaptcha.enterprise) {
        return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.head.appendChild(script);
};


export const executeRecaptchaAndSubmitUtil = async (): Promise<void> => {
    try {
        if (window.grecaptcha && window.grecaptcha.enterprise) {
            await new Promise<void>((resolve) => {
                window.grecaptcha.enterprise.ready(resolve);
            });
            const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
            if (!recaptchaSiteKey) throw new Error('Recaptch verification failed. Please try again.');
            const recaptchaToken = await window.grecaptcha.enterprise.execute(
                recaptchaSiteKey,
                { action: 'LOGIN' }
            );
            const response = await verifyRecaptchaTokenAPI(recaptchaToken);
            if (response.data) {
                const data = response.data;
                if (data && data.isBot) {
                    throw new Error('Recaptch verification failed. Please try again.');
                }
                return;
            } else {
                throw new Error('RECAPTCHA verification failed. Please try again.');
            }
        } else {
            throw new Error('reCAPTCHA not initialized. Please try again later.');
        }
    } catch (error) {
        const errorMessage = error instanceof Error
            ? error.message
            : 'Error executing reCAPTCHA';
        throw new Error(errorMessage);
    }
};
